import { createSelector } from 'reselect';
import { trim } from '../../../utilities/trim.esm.js';
import { defaultCategorySelector } from './default-category-selector.esm.js';

function getCurrentCategory(defaultOption, selectedCategory) {
  var label = trim(selectedCategory);
  if (label && selectedCategory) {
    return {
      label: label,
      id: selectedCategory
    };
  }
  return defaultOption;
}
var currentCategorySelector = createSelector(defaultCategorySelector, function (props) {
  return props.selectedCategory;
}, getCurrentCategory);

export { currentCategorySelector };
//# sourceMappingURL=current-category-selector.esm.js.map
